import { create } from 'zustand';
import { ApiUtils, ApplicationApi, type AssignApplicationRequest, type StoreBaseReturn } from '@shared/api';

interface UseAssignApplicationStore {
  loading: boolean;
  data: boolean;
  error: string | null;
  assignApplication: (request: AssignApplicationRequest, signal?: AbortSignal) => Promise<StoreBaseReturn<boolean>>;
  clear: () => void;
}

export const useAssignApplicationStore = create<UseAssignApplicationStore>((set) => ({
  loading: false,
  data: false,
  error: null,

  assignApplication: async (request, signal) => {
    try {
      set({ loading: true, data: false, error: null });
      await ApplicationApi.assignApplication(request, signal);
      set({ loading: false, data: true });
      return { loading: false, data: true, error: null };
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
      return { loading: false, data: false, error: ApiUtils.getApiError(error) };
    }
  },

  clear: () => set({ loading: false, data: false, error: null }),
}));
